import { motion } from 'framer-motion';
import React from 'react';

const variants = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.4, 0, 0.2, 1] } },
  exit: { opacity: 0, y: -24, transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] } },
};

const PageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <motion.div
    initial="initial"
    animate="animate"
    exit="exit"
    variants={variants}
    style={{ height: '100%', paddingTop: '64px' }}
  >
    {children}
  </motion.div>
);

export default PageTransition;
